import { render, staticRenderFns } from "./FacilityAddress.vue?vue&type=template&id=0a385f3a&scoped=true&"
import script from "./FacilityAddress.vue?vue&type=script&lang=js&"
export * from "./FacilityAddress.vue?vue&type=script&lang=js&"
import style0 from "./FacilityAddress.vue?vue&type=style&index=0&id=0a385f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a385f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
